import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import itemNS from './constants/revenueNS';

export default data => {
  const dataModify = parseToMutationRequest(data, itemNS);
  const modifyRevenueMilestone = `modifyRevenueMilestone(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyRevenueMilestone} {
      id
    }
  }
`;
};
